import React from "react";

const repeatLogos = (logos) => [...logos, ...logos];

export function LogoSlider({ logos, speed = 60, direction = "left" }) {
  const animationDirection = direction === "right" ? "reverse" : "normal";
  const duration = `${speed}s`;
  const items = repeatLogos(logos);

  return (
    <div className="logo-slider" data-testid="logo-slider">
      <div
        className="logo-slider-track"
        style={{
          "--logo-slider-duration": duration,
          "--logo-slider-direction": animationDirection,
        }}
      >
        {items.map((logo, index) => (
          <div
            key={`${index}-${typeof logo === "string" ? logo : "logo"}`}
            className="logo-slider-item"
            aria-hidden={index >= logos.length}
          >
            {logo}
          </div>
        ))}
      </div>
    </div>
  );
}
